import React from "react";

import CustomAutoCompleteFilter from "../lib/components/customdatagridfilter/CustomFilter";
import { CheckboxSelect } from "../lib/components/CheckboxSelect";
import { PIInvoiceLines, PIInvoiceNumbers } from "../lib/api/sale";
import { ColumnFiltersType, ColumnsWidthType } from "../lib/types/grid";
import { InvoiceLinesStatus } from "../lib/api/invoiceItemsAudit";

import Checkbox from "@material-ui/core/Checkbox";

import IconLock from "@material-ui/icons/Lock";
import IconBrightness from "@material-ui/icons/Brightness1";

import Tooltip from "@material-ui/core/Tooltip";

enum CellWidth {
  Tiny = 30,
  TinyX = 50,
}

const defaultColumnProperties = {
  resizable: true,
  sortable: true,
  filterable: true,
};

const StatusRobot = ({ color, tooltip }) => (
  <div>
    <Tooltip title={tooltip}>
      <IconBrightness style={{ color: color, display: "block", margin: "auto", border: "1px solid #333", borderRadius: "100%" }} />
    </Tooltip>
  </div>
);

const StatusFormatter = ({ row }) => {
  switch (row.status) {
    case "PERFECT":
      return <StatusRobot tooltip="PERFECT MATCH" color="green" />;
    case "BEST":
      return <StatusRobot tooltip="BEST MATCH" color="orange" />;
    case "NONE":
      return <StatusRobot tooltip="NO MATCH" color="red" />;
    default:
      return <StatusRobot tooltip="NO MATCH" color="red" />;
  }
};

const shouldRenderLock = (row: PIInvoiceNumbers): boolean => row.merged == InvoiceLinesStatus.Merged || row.accepted == InvoiceLinesStatus.Accepted;

let currentSpace = true;

export const GridColumns = (
  data: PIInvoiceLines[],
  filters: ColumnFiltersType,
  arrangement: string[],
  columnsWidth: ColumnsWidthType[],
  selectedRows: PIInvoiceLines[],
  handleCheckboxSelect: (row: PIInvoiceNumbers) => void,
  handleSelectAll: () => void,
) => {
  let postValueInfo = "";

  if (data) {
    if (currentSpace) {
      postValueInfo = " ";
    }
    currentSpace = !currentSpace;
  }

  const columns = [
    {
      key: "merged",
      name: "#C" + postValueInfo,
      width: CellWidth.Tiny,
      formatter: ({ row }) => (
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", marginTop: "-8px" }}>
          <CheckboxSelect row={row} selectedRows={selectedRows} handleCheckboxSelect={handleCheckboxSelect} valueKey={"sale_invoicenumber"} />
        </div>
      ),
      filterRenderer: () => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
          <Checkbox checked={selectedRows.length > 0} onChange={handleSelectAll} />
        </div>
      ),
    },
    {
      key: "status",
      name: "#S" + postValueInfo,
      width: CellWidth.Tiny,
      formatter: StatusFormatter,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"status"} data={data} section={"mgpintegration"} />;
      },
    },
    {
      key: "mergedFormatted",
      name: "Locked" + postValueInfo,
      width: CellWidth.Tiny,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"mergedFormatted"} data={data} section={"mgpintegration"} />;
      },
      formatter: ({ row }) => {
        return <div style={{ display: "flex", justifyContent: "center" }}>{shouldRenderLock(row) ? <IconLock /> : <></>}</div>;
      },
    },
    {
      key: "sale_invoicenumber",
      name: "Invoice Number" + postValueInfo,
      width: CellWidth.TinyX,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"sale_invoicenumber"} data={data} section={"mgpintegration"} />;
      },
    },
    {
      key: "sale_date",
      name: "Sale Month" + postValueInfo,
      width: CellWidth.TinyX,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"sale_date"} data={data} section={"mgpintegration"} />;
      },
    },
    {
      key: "producer_codes",
      name: "Producer" + postValueInfo,
      width: CellWidth.TinyX,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"producer_codes"} data={data} section={"mgpintegration"} />;
      },
    },
  ].map((c) => ({ ...c, ...defaultColumnProperties }));

  const columnsArranged = [];

  if (arrangement && arrangement.length > 0) {
    arrangement.map((item) => {
      const indexOfItem = columns.indexOf(columns.find((col) => col.name.trim() == item.toString().trim()));
      if (indexOfItem != -1) {
        columnsArranged.push(columns[indexOfItem]);
      }
    });
  } else {
    columns.map((colItem) => {
      columnsArranged.push(colItem);
    });
  }

  if (columnsWidth && columnsWidth.length > 0) {
    for (let index = 0; index < columnsArranged.length; index++) {
      const element = columnsArranged[index];
      const colItem = columnsWidth.find((colwitem) => colwitem.name.trim() == element.name.trim());
      if (colItem) {
        element.width = colItem.width;
      }
    }
  }

  return columnsArranged;
};
